import { JoyField, JoyProperty, JoyObjectType, JoyMedium, JoyDataService, JoyDataServiceQueryOption, isBoolean, isString, isJoyPropertiesArray, isJoyStatusArray, } from 'joy-core';
import JoyPhotosession from '../objects/JoyPhotosession';
export default class JoyPhotosessionHelper {
    /**
     * Create a new Photosession document.
     * @param dealId The identifier of the deal in which the document will be placed, string.
     * @param title The photosession title, string.
     * @param description The Photosession description, optional, string.
     */
    static async create(dealId, title, description) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.album;
        data[JoyField.props] = [JoyProperty.photosession];
        data[JoyField.group] = dealId;
        data[JoyField.name] = title;
        if (isString(description)) {
            data[JoyField.description] = description;
        }
        let result = await JoyDataService.instance.create(data);
        try {
            return new JoyPhotosession(result);
        }
        catch (error) {
            throw Error('Invalid input data for JoyPhotosession');
        }
    }
    /**
     * Fetch a Photosession document.
     * @param id The identifier of the document to fetch.
     * @param dealId The identifier of the deal to which the document belongs.
     */
    static async get(id, dealId) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.album;
        data[JoyField.group] = dealId;
        data[JoyField.id] = id;
        let result = await JoyDataService.instance.read(data);
        try {
            return new JoyPhotosession(result);
        }
        catch (error) {
            throw Error('Invalid input data for JoyPhotosession');
        }
    }
    /**
     * Remove a Photosession document.
     * @param id The identifier of the document to be removed.
     * @param groupId the identifier of the deal to which the document belongs.
     */
    static async delete(id, dealId) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.album;
        data[JoyField.id] = id;
        data[JoyField.group] = dealId;
        await JoyDataService.instance.delete(data);
        return;
    }
    /**
     * Get the identifier of the watermarked album of a Photosession document.
     * @param photosessionId The identifier of the photosession.
     * @param dealId The identifier of the deal to which the photosession belongs.
     */
    static async getWatermark(photosessionId, dealId) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.album;
        data[JoyField.props] = [JoyProperty.watermark];
        data[JoyField.group] = dealId;
        data[JoyField.album] = photosessionId;
        let result = await JoyDataService.instance.read(data);
        let albumId = result[JoyField.objectId];
        if (isString(albumId)) {
            return albumId;
        }
        throw Error('Invalid response data for props-related photosession');
    }
    /**
     * Fetch the Medium documents that belong to this photosession.
     * @param photosessionId The identifier of the photosession.
     * @param dealId The identifier of the deal to which the photosession belongs.
     * @param count Maximum number of documents to retrieve, 0 means all.
     * @param status A JoyStatus value, optional.
     * @param properties An array of JoyProperties, optional.
     * @param isPublic A boolean value indicating if the mediums are public, optional.
     */
    static async getMediums(photosessionId, dealId, count = 0, status, properties, isPublic) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.medium;
        data[JoyField.group] = dealId;
        data[JoyField.album] = photosessionId;
        if (isJoyStatusArray(status)) {
            data[JoyField.status] = status;
        }
        if (isJoyPropertiesArray(properties)) {
            data[JoyField.props] = properties;
        }
        if (isBoolean(isPublic)) {
            data[JoyField.isPublic] = isPublic;
        }
        let options = new Map();
        options[JoyDataServiceQueryOption.limit] = count;
        let result = await JoyDataService.instance.read(data, options);
        let mediums = [];
        for (const data of result) {
            try {
                mediums.push(new JoyMedium(data));
            }
            catch (error) {
                throw Error('Invalid input for JoyMedium.');
            }
        }
        return mediums;
    }
}
//# sourceMappingURL=JoyPhotosessionHelper.js.map